module.exports = __webpack_public_path__ + "img/cf.25aedd56.jpeg";